class Gamut {
  constructor(requirements, inputcolor, currentUser = []) {
    this.requirements = requirements;
    this.inputcolor = inputcolor;
    this.currentUser = currentUser;
  }

  /* validate function if any payload parameter is missing */
  validate() {
    /* Apply post function schema file in validate function */
    if (!this.requirements.thickness || !this.requirements.thickness) {
      throw new Error("Name and Email are required.");
    }
  }

  /* Generate the Gamut Graph payload data of service */

  getPayload() {
    let percentageRecyledResinConc = 0;
    if (
      this.requirements?.resinRequirement?.newResinRecycled?.dilutionDetails
        ?.recycledResinConc
    ) {
      percentageRecyledResinConc = parseFloat(
        this.requirements.resinRequirement.newResinRecycled.dilutionDetails
          .recycledResinConc
      );
    } else {
      percentageRecyledResinConc = parseFloat(
        this.requirements?.selectedRecycledResin?.dilution_percentage_recycled
      );
    }
    return {
      production: {
        thickness: parseFloat(this.requirements.thickness),
        let_down_ratio: parseFloat(this.requirements.ldr),
        production_desired_recycled_resin_concentration: parseFloat(
          this.requirements.recycledResinConc
        ),
      },
      source_material: {
        resin_class: this.requirements.resinClass,
        percentage_recycled_resin_concentration: percentageRecyledResinConc,
        virgin_resin: this.getVirginResin(),
        recycled_resin: this.getRecycledResin(),
      },
      target_color: this.getTargetColor(),
    };
  }

  selectResinClass(requirements) {
    /* 
            CNN-7992 - User is able to choose resin type (resin class)
            Decide the resin class from the values 
        */
    let resinClass;
    if (
      requirements.selectedVirginResin !== "" ||
      requirements.selectedRecycledResin !== ""
    ) {
      resinClass = "";
    } else {
      resinClass = requirements.resinClass;
    }
    return resinClass;
  }

  getVirginResin() {
    let virginResin = {};
    if (this.requirements.selectedVirginResin) {
      virginResin = {
        thickness: parseFloat(
          this.requirements?.selectedVirginResin?.thickness
        ),
        r_curve: this.requirements?.selectedVirginResin?.r_curve,
        t_curve: this.requirements?.selectedVirginResin?.t_curve,
      };
    } else {
      virginResin = {
        thickness: parseFloat(
          this.requirements.resinRequirement.newResinvirgin.thickness
        ),
        r_curve:
          this.requirements?.resinRequirement?.newResinvirgin?.rtCurve?.rCurve,
        t_curve:
          this.requirements?.resinRequirement?.newResinvirgin?.rtCurve?.tCurve,
      };
    }
    return virginResin;
  }

  getRecycledResin() {
    let recycledeResin = {};
    if (this.requirements.selectedRecycledResin) {
      recycledeResin = {
        thickness: parseFloat(
          this.requirements?.selectedRecycledResin?.thickness
        ),
        r_curve: this.requirements?.selectedRecycledResin?.r_curve,
        t_curve: this.requirements?.selectedRecycledResin?.t_curve,
      };
    } else {
      recycledeResin = {
        thickness: parseFloat(
          this.requirements.resinRequirement.newResinRecycled.thickness
        ),
        r_curve:
          this.requirements?.resinRequirement?.newResinRecycled?.rtCurve
            ?.rCurve,
        t_curve:
          this.requirements?.resinRequirement?.newResinRecycled?.rtCurve
            ?.tCurve,
      };
    }
    return recycledeResin;
  }

  getTargetColor() {
    const opacity = [];
    /* Function for get the LAB values from the target cxf file */
    const labColor = this.inputcolor.uploadedColorArray.map(
      (element, index) => {
        if (element.opacity) {
          opacity.push(element.opacity);
        } else {
          opacity.push(0);
        }
        return [element.L, element.a, element.b];
      }
    );

    return [
      {
        lab: labColor,
        opacity: opacity,
      },
    ];
  }

  getEvaluationReoprtPayload() {
    let tar_number = "";
    let cadr_number = "";
    if (this.requirements.requestType === "tar") {
      if (this.requirements?.requestNumber.length > 9) {
        tar_number = this.requirements?.requestNumber
          .slice(0, 9)
          .replace(/[_]/g, "");
        if (tar_number.length <= 8) {
          tar_number = tar_number.replace(/[-]/g, "");
        }
      } else {
        tar_number = this.requirements?.requestNumber;
      }
    } else {
      if (this.requirements?.requestNumber.length > 12) {
        cadr_number = this.requirements?.requestNumber.slice(0, 12);
      } else {
        cadr_number = this.requirements?.requestNumber;
      }
    }
    return {
      user_email_address: this.currentUser?.email,
      remark: this.requirements?.remarks,
      tar_number: tar_number.replace(/[_]/g, ""),
      cadr_number: cadr_number.replace(/[_-]/g, ""),
      created_at: new Date(),
      updated_at: new Date(),
    };
  }
}

export default Gamut;
